import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectLetterTargetsModalComponent } from './select-letter-targets-modal.component';
import { SelectLetterTargetsComponent } from './select-letter-targets.component';
import { SelectLetterTargetsGuard } from './select-letter-targets.guard';

const routes: Routes = [
  // { path: ':group_id', canActivate:[SelectLetterTargetsGuard], component:SelectLetterTargetsModalComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectLetterTargetsRoutingModule { }
